"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findEventsOnOrderQuery = exports.orderQuery = exports.allOrdersQuery = exports.findMinimalOrderByIdQuery = exports.findOrderByIdWithBosCustomerQuery = exports.findOrderByIdQuery = void 0;
const types_1 = require("../../types");
exports.findOrderByIdQuery = `
  query findOrderById($id: ID!) {
    findOrderById(id: $id) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.findOrderByIdWithBosCustomerQuery = `
  query findOrderById($id: ID!) {
    findOrderById(id: $id) {
      ...order
    }
  }
  ${types_1.orderFragmentsWithBos}
`;
exports.findMinimalOrderByIdQuery = `
  query findOrderById($id: ID!) {
    findOrderById(id: $id) {
      ...order
    }
  }
  ${types_1.minimalOrderFragments}
`;
exports.allOrdersQuery = `
  query allOrders {
    allOrders {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.orderQuery = `
  query orderQuery($input: OrderQueryInput) {
    orderQuery(input: $input) {
      id
      pagination {
        ${types_1.paginationFields}
      }
      sorting {
        ${types_1.sortingFields}
      }
      filters {
        ${types_1.orderQueryFilterFields}
      }
      results {
        ...order
      }
    }
  }
  ${types_1.orderFragmentsWithBos}
`;
exports.findEventsOnOrderQuery = `
  query findEventsOnOrder($id: ID!) {
    findEventsOnOrder(id: $id) {
      id
      events {
        ...orderEvent
      }
    }
  }
  ${types_1.orderEventFragment}
`;
//# sourceMappingURL=order.js.map